module.exports = __webpack_public_path__ + "img/dribbling.221e818b.svg";